import {
	ChangedDeviceDetails,
	DeviceDetails,
	UpdateAction,
	UpdateCertificatePayload,
} from '@types';

const updateCertificatePayloadEmpty: UpdateCertificatePayloadEmpty = {
	action: UpdateAction.NONE,
	submit: false,
	providedAuthorisationReference: undefined,
	newDeviceDetails: {
		makeAndModelType: '00000000-0000-0000-0000-000000000000',
		serialNumber: undefined,
		size: undefined,
		latitude: undefined,
		longitude: undefined,
		gpsDatum: undefined,
	},
	changedExistingDeviceDetails: {
		makeAndModelType: '00000000-0000-0000-0000-000000000000',
		serialNumber: undefined,
		size: undefined,
		latitude: undefined,
		longitude: undefined,
		gpsDatum: undefined,
		changeMake: undefined,
		changeModel: undefined,
		changeDeviceType: undefined,
	},
	compliantMD: undefined,
	nonComplianceStatement: undefined,
	modificationsRequired: undefined,
	inspectedDate: undefined,
	inspectionOutcome: undefined,
	diagnosticsRecordShared: undefined,
	configurationSettingsShared: undefined,
	openChannelCalibrationReportShared: undefined,
	mdComponents: [],
	seals: [],
	photos: [],
	reading: undefined,
};

export default updateCertificatePayloadEmpty as UpdateCertificatePayload;

type DeviceDetailsEmpty = {
	[K in keyof DeviceDetails]: DeviceDetails[K] | undefined | undefined;
};

type ChangedDeviceDetailsEmpty = {
	[K in keyof ChangedDeviceDetails]: ChangedDeviceDetails[K] | undefined | undefined;
};

type UpdateCertificatePayloadEmpty = {
	[K in keyof UpdateCertificatePayload]: K extends 'newDeviceDetails'
		? DeviceDetailsEmpty
		: K extends 'changedExistingDeviceDetails'
			? ChangedDeviceDetailsEmpty
			: UpdateCertificatePayload[K] | undefined;
};
